// TODO: remover ao integrar a API — ver SPRINT.md seção 14.1
export const AUDBILITY_USER_DETAILS_MOCK = {
  availableScreeningsPtBr: 15,
  availableScreeningsPtEu: 5,
  patientsCount: 0,
  purchasedScreenings: 0,
  consumedScreenings: 0,
  purchases: [],
};
